// This file is auto-generated by @hey-api/openapi-ts

import type { AccountsApiKeysListResponse, AnnotationsCreateResponse, AnnotationsListResponse, AnnotationsPartialUpdateResponse, AnnotationsRetrieveResponse, AnnotationsUpdateResponse, ChaptersCreateResponse, ChaptersListResponse, ChaptersPartialUpdateResponse, ChaptersRetrieveResponse, ChaptersUpdateResponse, CheckoutsChannelsRetrieveResponse, CheckoutsCreateResponse, CheckoutsInvoiceRetrieveResponse, CheckoutsSuccessRetrieveResponse, CheckoutsThanksRetrieveResponse, DubsListResponse, DubsPartialUpdateResponse, DubsRetrieveResponse, DubsUpdateResponse, ProfilePartialUpdateResponse, ProfileRetrieveResponse, PulseAnnotationAnalyticsRetrieveResponse, PulseChapterAnalyticsRetrieveResponse, PulseListResponse, PulseRetrieveResponse, VideosAnnotationsListResponse, VideosChaptersListResponse, VideosCreateResponse, VideosListResponse, VideosPartialUpdateResponse, VideosRetrieveResponse, VideosUpdateResponse } from './types.gen';

const apiKeySchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const accountsApiKeysListResponseTransformer = async (data: any): Promise<AccountsApiKeysListResponse> => {
    data = data.map((item: any) => apiKeySchemaResponseTransformer(item));
    return data;
};

const channelSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    if (data.subscription_expires_at) {
        data.subscription_expires_at = new Date(data.subscription_expires_at);
    }
    return data;
};

const profileReadSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    if (data.last_login) {
        data.last_login = new Date(data.last_login);
    }
    data.channel = channelSchemaResponseTransformer(data.channel);
    return data;
};

export const profileRetrieveResponseTransformer = async (data: any): Promise<ProfileRetrieveResponse> => {
    data = profileReadSchemaResponseTransformer(data);
    return data;
};

export const profilePartialUpdateResponseTransformer = async (data: any): Promise<ProfilePartialUpdateResponse> => {
    data = profileReadSchemaResponseTransformer(data);
    return data;
};

const annotationSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const annotationsListResponseTransformer = async (data: any): Promise<AnnotationsListResponse> => {
    data = data.map((item: any) => annotationSchemaResponseTransformer(item));
    return data;
};

export const annotationsCreateResponseTransformer = async (data: any): Promise<AnnotationsCreateResponse> => {
    data = annotationSchemaResponseTransformer(data);
    return data;
};

export const annotationsRetrieveResponseTransformer = async (data: any): Promise<AnnotationsRetrieveResponse> => {
    data = annotationSchemaResponseTransformer(data);
    return data;
};

export const annotationsPartialUpdateResponseTransformer = async (data: any): Promise<AnnotationsPartialUpdateResponse> => {
    data = annotationSchemaResponseTransformer(data);
    return data;
};

export const annotationsUpdateResponseTransformer = async (data: any): Promise<AnnotationsUpdateResponse> => {
    data = annotationSchemaResponseTransformer(data);
    return data;
};

const chapterSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const chaptersListResponseTransformer = async (data: any): Promise<ChaptersListResponse> => {
    data = data.map((item: any) => chapterSchemaResponseTransformer(item));
    return data;
};

export const chaptersCreateResponseTransformer = async (data: any): Promise<ChaptersCreateResponse> => {
    data = chapterSchemaResponseTransformer(data);
    return data;
};

export const chaptersRetrieveResponseTransformer = async (data: any): Promise<ChaptersRetrieveResponse> => {
    data = chapterSchemaResponseTransformer(data);
    return data;
};

export const chaptersPartialUpdateResponseTransformer = async (data: any): Promise<ChaptersPartialUpdateResponse> => {
    data = chapterSchemaResponseTransformer(data);
    return data;
};

export const chaptersUpdateResponseTransformer = async (data: any): Promise<ChaptersUpdateResponse> => {
    data = chapterSchemaResponseTransformer(data);
    return data;
};

const stripeCheckoutSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    if (data.invoice_issued_at) {
        data.invoice_issued_at = new Date(data.invoice_issued_at);
    }
    if (data.invoice_paid_at) {
        data.invoice_paid_at = new Date(data.invoice_paid_at);
    }
    if (data.invoice_period_start) {
        data.invoice_period_start = new Date(data.invoice_period_start);
    }
    if (data.invoice_period_end) {
        data.invoice_period_end = new Date(data.invoice_period_end);
    }
    return data;
};

export const checkoutsCreateResponseTransformer = async (data: any): Promise<CheckoutsCreateResponse> => {
    data = stripeCheckoutSchemaResponseTransformer(data);
    return data;
};

const invoiceSchemaResponseTransformer = (data: any) => {
    if (data.issued_at) {
        data.issued_at = new Date(data.issued_at);
    }
    if (data.paid_at) {
        data.paid_at = new Date(data.paid_at);
    }
    return data;
};

const stripeCheckoutSuccessSchemaResponseTransformer = (data: any) => {
    if (data.invoice) {
        data.invoice = invoiceSchemaResponseTransformer(data.invoice);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const checkoutsInvoiceRetrieveResponseTransformer = async (data: any): Promise<CheckoutsInvoiceRetrieveResponse> => {
    data = stripeCheckoutSuccessSchemaResponseTransformer(data);
    return data;
};

export const checkoutsSuccessRetrieveResponseTransformer = async (data: any): Promise<CheckoutsSuccessRetrieveResponse> => {
    data = stripeCheckoutSuccessSchemaResponseTransformer(data);
    return data;
};

export const checkoutsThanksRetrieveResponseTransformer = async (data: any): Promise<CheckoutsThanksRetrieveResponse> => {
    data = stripeCheckoutSuccessSchemaResponseTransformer(data);
    return data;
};

const paginatedCheckoutListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => stripeCheckoutSuccessSchemaResponseTransformer(item));
    return data;
};

export const checkoutsChannelsRetrieveResponseTransformer = async (data: any): Promise<CheckoutsChannelsRetrieveResponse> => {
    data = paginatedCheckoutListSchemaResponseTransformer(data);
    return data;
};

const dubSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const dubsListResponseTransformer = async (data: any): Promise<DubsListResponse> => {
    data = data.map((item: any) => dubSchemaResponseTransformer(item));
    return data;
};

export const dubsRetrieveResponseTransformer = async (data: any): Promise<DubsRetrieveResponse> => {
    data = dubSchemaResponseTransformer(data);
    return data;
};

export const dubsPartialUpdateResponseTransformer = async (data: any): Promise<DubsPartialUpdateResponse> => {
    data = dubSchemaResponseTransformer(data);
    return data;
};

export const dubsUpdateResponseTransformer = async (data: any): Promise<DubsUpdateResponse> => {
    data = dubSchemaResponseTransformer(data);
    return data;
};

const eventSchemaResponseTransformer = (data: any) => {
    data.timestamp = new Date(data.timestamp);
    return data;
};

const paginatedEventListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => eventSchemaResponseTransformer(item));
    return data;
};

export const pulseListResponseTransformer = async (data: any): Promise<PulseListResponse> => {
    data = paginatedEventListSchemaResponseTransformer(data);
    return data;
};

export const pulseRetrieveResponseTransformer = async (data: any): Promise<PulseRetrieveResponse> => {
    data = eventSchemaResponseTransformer(data);
    return data;
};

export const pulseAnnotationAnalyticsRetrieveResponseTransformer = async (data: any): Promise<PulseAnnotationAnalyticsRetrieveResponse> => {
    data = eventSchemaResponseTransformer(data);
    return data;
};

export const pulseChapterAnalyticsRetrieveResponseTransformer = async (data: any): Promise<PulseChapterAnalyticsRetrieveResponse> => {
    data = eventSchemaResponseTransformer(data);
    return data;
};

const videoSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const videosListResponseTransformer = async (data: any): Promise<VideosListResponse> => {
    data = data.map((item: any) => videoSchemaResponseTransformer(item));
    return data;
};

const uploadVideoSchemaResponseTransformer = (data: any) => {
    data.video = videoSchemaResponseTransformer(data.video);
    return data;
};

export const videosCreateResponseTransformer = async (data: any): Promise<VideosCreateResponse> => {
    data = uploadVideoSchemaResponseTransformer(data);
    return data;
};

export const videosRetrieveResponseTransformer = async (data: any): Promise<VideosRetrieveResponse> => {
    data = videoSchemaResponseTransformer(data);
    return data;
};

export const videosPartialUpdateResponseTransformer = async (data: any): Promise<VideosPartialUpdateResponse> => {
    data = videoSchemaResponseTransformer(data);
    return data;
};

export const videosUpdateResponseTransformer = async (data: any): Promise<VideosUpdateResponse> => {
    data = videoSchemaResponseTransformer(data);
    return data;
};

export const videosAnnotationsListResponseTransformer = async (data: any): Promise<VideosAnnotationsListResponse> => {
    data = data.map((item: any) => annotationSchemaResponseTransformer(item));
    return data;
};

export const videosChaptersListResponseTransformer = async (data: any): Promise<VideosChaptersListResponse> => {
    data = data.map((item: any) => chapterSchemaResponseTransformer(item));
    return data;
};
